import { SnowplowService } from 'wanderu-service-analytics';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEvent({
    action,
    category: 'user_survey_search',
    label,
    property,
});

const clickScoreEvent = (label) => sendEvent('click', label);
const submitFeedbackEvent = (property) => sendEvent('submit', 'survey_feedback', property);
const submitDropdownEvent = (option) => sendEvent('submit', 'survey_dropdown', { option });

const events = {
    clickScoreEvent,
    submitDropdownEvent,
    submitFeedbackEvent,
};

export default events;
